import { useState, useEffect, useLayoutEffect } from 'react';
import { siderWidth } from '../../../constants/layout'


import CloseButton from '../../layouts/CloseButton';
import FilterInputBuilder from '../../filterInputBuilder/userFilter';
import OpenButton from '../../layouts/OpenButton';
import { contentPadding } from '../../layouts/layoutHelper';

import { FilterProvider } from '../../../context/FilterContext';
import MotionLayout from '../../general/framer-motion/MotionLayout';
import PortfolioRealizedTbl from '../../tables/PortfolioRealizedTbl';
import PortfolioUnrealizedTbl from '../../tables/PortfolioUnrealizedTbl';

import { ReactComponent as TrendingIC } from '../../asset/images/icon/trending-up.svg';
import { ReactComponent as CalenderIC } from '../../asset/images/icon/calendar.svg';
import { getStock } from '../../../apis/feedProvider';
import { checkPagePermission } from '../../../constants/page-control';

import { useLocation, useNavigate } from 'react-router-dom';
import { useFilter } from "../../../context/FilterContext";

import { getUserDetail,useLocalStorageListener,setLogout } from '../../../hooks/handleUserLocalStorage';



const Index = ({ title = null,settlementType=null }:any) => {
    let navigate = useNavigate();
    // const [cookies, setCookie, removeCookie] = useCookies(['user']);
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);

    const [accounts, setAccounts] = useState([]);
    const [inputs, setInputs] = useState({});
    const [cTab, setCTab] = useState(null);

    const [unrealizedFilterType, setUnrealizedFilterType] = useState("account");
    // const [resetFilterInput, setResetFilterInput] = useState({});
    

    // useEffect(() => {
    //     if(cookies.user?.tools){   
    //         let allowAccess = checkPagePermission(cookies.user?.tools,"portfolio");
    //         if(!allowAccess){
    //             navigate("/accessdenied", {  });
    //         }
    //     }
    //   //  test();
    // }, []);

    useLocalStorageListener((newUserValue) => {
        let localUser = getUserDetail();
        if(!localUser) return;
        if(localUser.user?.tools){   
            let allowAccess = checkPagePermission(localUser.user?.tools,"portfolio");
            if(!allowAccess){
                navigate("/accessdenied", {  });
            }
        }
    });

    useLayoutEffect(() => {
     
        //reset if switch to realized tab
        if(cTab == "Realized"){
            setUnrealizedFilterType("account");
          
        }



    }, [cTab,unrealizedFilterType]);

   

    const handleSidebarToggle = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };

    const convertPropertyToOptions = (obj:any) => {
        // Convert object entries to array format
        const options = Object.entries(obj).map(([key, value]) => ({
          value: key,
          label: value
        }));
      
        // Add the "All" option at the beginning
        options.unshift({ value: '', label: 'All' });
      
        return options;
    };

    const filterColumns = cTab == "Unrealized" ?
    (
        unrealizedFilterType == "account" ?
        [
            {
                type: "selectUser",
                initialSelectFirst:false,//disable initial select first
                singleMode:false
                // targetKeys:["accounts[]"],
                // clearKeyWhenSelected:["exchanges","stocks"]
            },
            {
                type: "selectExchangeAndStock",
                // targetKeys:["exchanges","stocks"],
                // clearKeyWhenSelected:["accounts[]"]
            },
        
        ]:
        [
            {
                type: "selectUser",
                initialSelectFirst:false,//disable initial select first
                singleMode:false
                // targetKeys:["accounts[]"],
                // clearKeyWhenSelected:["exchanges","stocks"]
            },
            {
                type: "selectExchangeAndStock",
                // targetKeys:["exchanges","stocks"],
                // clearKeyWhenSelected:["accounts[]"]
            },
        ]
    )
    :
    [
        {
            type: "selectUser",
            initialSelectFirst:false,//disable initial select first,
            singleMode:false
        },
        {
            type: "selectExchangeAndStock",
            // targetKeys:["exchanges","stocks"],
            // clearKeyWhenSelected:["accounts[]"]
        },
    ]

    
  

    return (
        <MotionLayout>
            <FilterProvider>
                <div className={`page-layout  ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                    <div className="side-bar" style={{
                        width: isSidebarCollapsed ? '0' : siderWidth
                    }}>
                        <CloseButton 
                            handleClick={handleSidebarToggle}
                        />
                        <div className='content' style={{width:siderWidth}}>
                            <div className='pt-3'></div>
                            {/* {
                                cTab == "Unrealized" &&
                                <div className="col-xxxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                                    {' '}
                                    {unrealizedFilterType}
                                    <div className="input-container ">
                                        <div className="label"> Filter By </div>
                                        <select className="custom" 
                                            value={unrealizedFilterType}
                                            onChange={(e) => {
                                                setUnrealizedFilterType(e.target.value) 
                     
                                            }}
                                        >
                                            <option value={"account"}>
                                                {"Account No"}
                                            </option>
                                            <option  value={"exchange_stock"}>
                                                {"Exchange / Stock "}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            } */}
                          
                            {
                                cTab
                                &&
                                unrealizedFilterType
                                &&
                                <FilterInputBuilder 
                                    loading={tableLoading}
                                    columns={filterColumns} 
                                    initSearchWhenReceived={[`accounts[]`]}  
                                    initSearchWhenReceivedAllowEmpty={true}
                                    onSearchSubmit={(inputs:any)=>{
                                        let accounts = inputs['accounts[]'] || [];
                                        setAccounts(accounts)
                                        //force trigger search
                                        setInputs(JSON.parse(JSON.stringify(inputs)));
                                    }}
                                    // resetInput={resetFilterInput}
                                />
                            }
                            
                        </div>
                    
                    </div>
                    <div className="main-content " style={{
                        marginLeft: isSidebarCollapsed ? '0px' : siderWidth,
                        paddingLeft: isSidebarCollapsed ? '0px' : '20px',
                    }}>
                        <OpenButton 
                            isSidebarCollapsed={isSidebarCollapsed}
                            handleClick={handleSidebarToggle}
                        />
                        <div className={ contentPadding(isSidebarCollapsed)}>
                            <div>
                                <div className="main-title">Portfolio</div>
                                <TabsContainer currentTab={async (cTab:any)=>{
                                    //reset filter when switch tab
                                    // setResetFilterInput({
                                    //     startReset:true
                                    // })
                                    setCTab(cTab)
                                }}/>
                            </div>
                        </div>
                        
                    
                    </div>
                </div>
            </FilterProvider>
        </MotionLayout>
    );
};

const TabsContainer = (props: any) => {
    const [cTab, setCTab] = useState("Unrealized");

    let infoBoxSource = [
        {
            img: <CalenderIC />,
            title: 'Last Updated',
            value: '8/08/2022 08:08PM'
        },
        {
            img: <CalenderIC />,
            title: 'Start Date',
            value: '8/08/2022'
        }
    ];

    let main_report_data = [
        { label: 'Total Portfolio Value', value: '123,456,789.99' },
        { label: 'Available Cash', value: '123,456,789.99' },
        { label: 'TWR', value: '99.99%' },
        { label: 'Max. Drawdown', value: '99.99%' }
    ];

    let profile_lost_report_data = [
        { label: 'Profit & Loss' },
        { label: 'Floating', value: '123,456,789.99' },
        { label: 'Realized', value: '123,456,789.99' },
        { label: 'Daily', value: '123,456,789.99' },
        { label: 'Monthly', value: '123,456,789.99' },
        { label: 'YTD', value: '123,456,789.99' }
    ];

    let total_profit_loss_data = [
        { label: 'Total Profile', value: '123,456,789.99' },
        { label: 'Total Loss', value: '-123,456,789.99' }
    ];

    let cash_flow_data = [
        { label: 'Cash Flow' },
        { label: 'Deposit', value: '123,456,789.99' },
        { label: 'Withdrawals', value: '123,456,789.99' }
    ];
    
    
    useEffect(() => {
        if(props.currentTab){
            props.currentTab(cTab)
        }

    }, [cTab]);


    const ReportTable = (props: any) => {
        let data = props.data || [];

        return (
            <div className="report-table-container">
                {data.map(function (row: any, i: any) {
                    let colorClass = '';
                    if (row.value && row.value.match('-')) {
                        colorClass = 'red';
                    }

                    return (
                        <div className="row m-0" key={i}>
                            <div className="col-md-6 col-12 label">
                                {row.label}
                            </div>
                            <div
                                className={
                                    'col-md-6 col-12 value ' + colorClass
                                }
                            >
                                {row.value}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    const DetailTableComponents = () => {
        return (
            <div className="pl-2 pr-2">
                {' '}
                <div className="pt-4">
                    <ReportTable data={main_report_data} />
                </div>
                <div className="pt-4">
                    <ReportTable data={profile_lost_report_data} />
                </div>
                <div className="pt-4">
                    <ReportTable data={total_profit_loss_data} />
                </div>
                <div className="pt-4">
                    <ReportTable data={cash_flow_data} />
                </div>
                <div className="info-box-container pt-3">
                    <div className="item fullwidth">
                        {/* <img src={trendingIC} /> */}

                        <div className="p-3">
                            <TrendingIC />
                        </div>
                        <div className="detail">
                            <div className="title">Trades</div>
                            <div className="value">999,99</div>
                        </div>
                    </div>
                </div>
                {infoBoxSource.map(function (row, i) {
                    return (
                        <div className="info-box-container pt-3">
                            <div className="item fullwidth">
                                {/* <img src={row.img} /> */}
                                <div className="p-3">{row.img}</div>
                                <div className="detail">
                                    <div className="title">{row.title}</div>
                                    <div className="value">{row.value}</div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    const onTabChange = (tab: any) => {
        setCTab(tab);
        // alert(tab);
        if (props.onTabChange) {
            props.onTabChange(tab);
        }
    };

    return (
        <div className="">
            <ul
                className="nav nav-tabs custom-nav"
                id="research-reports-tabs"
                role="tablist"
            >
                <li
                    className="nav-item"
                    role="presentation"
                    onClick={() => onTabChange('Realized')}
                >
                    <button
                        className="nav-link "
                        id="Realized-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#Realized"
                        type="button"
                        role="tab"
                        aria-controls="Realized"
                        aria-selected="true"
                    >
                        Realized
                    </button>
                </li>
                <li
                    className="nav-item"
                    role="presentation"
                    onClick={() => onTabChange('Unrealized')}
                >
                    <button
                        className="nav-link active"
                        id="Unrealized-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#Unrealized"
                        type="button"
                        role="tab"
                        aria-controls="Unrealized"
                        aria-selected="true"
                    >
                        Unrealized
                    </button>
                </li>
            </ul>
            <div className="tab-content pt-3 fixed-height-container" id="">
                <div
                    className="tab-pane"
                    id="Realized"
                    role="tabpanel"
                    aria-labelledby="Realized-tab"
                >
                    {' '}
                    <div className="">
                        {
                            cTab === 'Realized' &&
                            <PortfolioRealizedTbl />
                        }
               
                    </div>
                </div>
                <div
                    className="tab-pane show active "
                    id="Unrealized"
                    role="tabpanel"
                    aria-labelledby="Unrealized-tab"
                >
                    {
                        cTab === 'Unrealized' &&
                        <PortfolioUnrealizedTbl />
                    }
               
                </div>
            </div>
        </div>
    );
};

export default Index;
